<template>
  <default-layout>
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <!-- DOWNGRADED FACILITIES -->
            <v-col cols="12" md="6" class="d-flex flex-column">
              <downgraded-facilities />
            </v-col>

            <!-- UPCOMING DOWNGRADES -->
            <v-col cols="12" md="6" class="d-flex flex-column">
              <upcoming-downgrades />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12">
              <downgrades-graph />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </default-layout>
</template>

<script>
import DowngradedFacilities from "@/components/Downgrades/DowngradedFacilities";
import UpcomingDowngrades from "@/components/Downgrades/UpcomingDowngrades";
import DowngradesGraph from "@/components/Downgrades/DowngradesGraph";
export default {
  name: "Downgrades",
  title: "Downgrades",
  components: {
    DowngradedFacilities,
    UpcomingDowngrades,
    DowngradesGraph,
  },
};
</script>

<style scoped></style>
